import { useEffect, useState } from "react";
import { getInlineLoader } from "../Helpers";
import banner1 from "../assets/sdl.png";
import "bootstrap/dist/css/bootstrap.min.css";
import { MdCall, MdEmail, MdWhatsapp } from "react-icons/md";
import { IoMdCalendar, IoMdCheckmark, IoMdDocument } from "react-icons/io";
import Footer from "../ones/Footer";
import TestimonialSlider from "../ones/TestimonialSlider";

export default function SDL() {
  const [ready, setReady] = useState(false);

  async function init() {
    setReady(false);
    setReady(true);
  }

  useEffect(() => {
    init();
  }, []);

  if (!ready)
    return (
      <div className="container mSupportLoading">
        {getInlineLoader()}
      </div>
    );

  return (
    <>
      <div
        className="MainBodySection bg-surface"
        style={{ paddingTop: "50px", paddingBottom: "50px" }}
      >
        <div className="container">
          <div className="row g-4 align-items-center">
            <div className="col-lg-6" data-aos="fade-right">
              <p className="text-uppercase fw-bold text-primary mb-2" style={{ letterSpacing: "1.5px", fontSize: "0.8rem" }}>
                Tax Compliance Service
              </p>
              <h2 className="main-section-title mb-3">SDL - Skills and Development Levy Filing</h2>
              <p className="text-muted">
                SDL is a statutory levy imposed on employers based on monthly payroll. We manage
                payroll assessment, SDL computation, and submission through the official systems
                to keep your business compliant.
              </p>
              <div className="d-flex flex-wrap gap-2 mt-3">
                <span className="badge rounded-pill text-bg-light fw-bold"><IoMdCheckmark className="me-1" /> Payroll assessment</span>
                <span className="badge rounded-pill text-bg-light fw-bold"><IoMdCheckmark className="me-1" /> SDL computation</span>
                <span className="badge rounded-pill text-bg-light fw-bold"><IoMdCheckmark className="me-1" /> Submission support</span>
              </div>
            </div>
            <div className="col-lg-6" data-aos="fade-left">
              <div className="rounded-4 p-3 bg-white shadow-sm">
                <img src={banner1} className="rounded w-100" alt="SDL filing" />
              </div>
            </div>
          </div>

          <div className="row g-4 mt-3">
            <div className="col-lg-5" data-aos="fade-up">
              <div className="p-4 rounded-4 bg-white shadow-sm h-100">
                <h5 className="fw-bold mb-3"><IoMdCalendar className="me-2 text-warning" /> Deadline</h5>
                <div className="alert alert-warning mb-0" role="alert" style={{ borderRadius: "12px" }}>
                  SDL filings must be completed <strong>before the 7th day of the following month</strong>.
                </div>
              </div>
            </div>
            <div className="col-lg-7" data-aos="fade-up" data-aos-delay="100">
              <div className="p-4 rounded-4 bg-white shadow-sm h-100">
                <h5 className="fw-bold mb-3"><IoMdDocument className="me-2 text-primary" /> What We Handle</h5>
                <ul className="list-unstyled mb-0" style={{ lineHeight: "1.9" }}>
                  <li><IoMdCheckmark className="me-2 text-success" /> SDL assessment based on payroll</li>
                  <li><IoMdCheckmark className="me-2 text-success" /> Monthly levy computation</li>
                  <li><IoMdCheckmark className="me-2 text-success" /> Filing through official systems</li>
                  <li><IoMdCheckmark className="me-2 text-success" /> Compliance tracking and records</li>
                </ul>
              </div>
            </div>
          </div>

          <div className="row g-4 mt-3">
            <div className="col-lg-7" data-aos="fade-up">
              <div className="p-4 rounded-4 bg-white shadow-sm h-100">
                <h5 className="fw-bold mb-3">Client Requirements</h5>
                <ul className="list-unstyled mb-0" style={{ lineHeight: "1.9" }}>
                  <li><IoMdCheckmark className="me-2 text-success" /> Full names</li>
                  <li><IoMdCheckmark className="me-2 text-success" /> TIN numbers</li>
                  <li><IoMdCheckmark className="me-2 text-success" /> Gross salary</li>
                  <li><IoMdCheckmark className="me-2 text-success" /> Allowances or benefits</li>
                </ul>
              </div>
            </div>
            <div className="col-lg-5" data-aos="fade-up" data-aos-delay="100">
              <div className="p-4 rounded-4 bg-dark text-white h-100">
                <h5 className="fw-bold mb-3">Why It Matters</h5>
                <p className="mb-0" style={{ color: "#cbd5e1" }}>
                  Proper SDL filing helps you avoid penalties, interest charges, and audit issues
                  that arise from late or inaccurate submissions.
                </p>
              </div>
            </div>
          </div>

          <section className="mt-5">
            <div className="container py-4">
              <div className="row justify-content-center">
                <div className="col-md-12 col-lg-8">
                  <div
                    className="rounded-4 p-5 text-center"
                    style={{
                      background: "linear-gradient(145deg, #f9f9f9, #ffffff)",
                      boxShadow: "0 6px 20px rgba(0, 0, 0, 0.05)",
                      border: "1px solid rgba(0, 0, 0, 0.03)",
                      maxWidth: "520px",
                      margin: "0 auto",
                    }}
                  >
                    <h6 className="mb-4 fw-semibold text-dark" style={{ fontSize: "1.1rem", letterSpacing: "0.3px" }}>
                      Contact Us to Start SDL Filing Support
                    </h6>
                    <div className="mb-4">
                      <div className="w-100" style={{ height: "1px", background: "linear-gradient(to right, transparent, #e0e0e0, transparent)" }}></div>
                    </div>
                    <div className="d-flex justify-content-center gap-5">
                      <a href="tel:+255758779913" className="text-decoration-none text-body d-flex flex-column align-items-center" style={{ transition: "none" }}>
                        <div className="bg-success bg-opacity-10 rounded-circle p-2 mb-2" style={{ width: "56px", height: "56px", display: "flex", alignItems: "center", justifyContent: "center" }}>
                          <MdCall size={32} color="#1b3766ff" />
                        </div>
                        <span className="fw-medium" style={{ fontSize: "0.9rem" }}>Call</span>
                      </a>
                      <a href="https://wa.me/255758779913" target="_blank" rel="noreferrer" className="text-decoration-none text-body d-flex flex-column align-items-center" style={{ transition: "none" }}>
                        <div className="bg-success bg-opacity-10 rounded-circle p-2 mb-2" style={{ width: "56px", height: "56px", display: "flex", alignItems: "center", justifyContent: "center" }}>
                          <MdWhatsapp size={32} color="#0c7c35ff" />
                        </div>
                        <span className="fw-medium" style={{ fontSize: "0.9rem" }}>WhatsApp</span>
                      </a>
                      <a href="mailto:efiling@werenium.com" className="text-decoration-none text-body d-flex flex-column align-items-center" style={{ transition: "none" }}>
                        <div className="bg-success bg-opacity-10 rounded-circle p-2 mb-2" style={{ width: "56px", height: "56px", display: "flex", alignItems: "center", justifyContent: "center" }}>
                          <MdEmail size={32} color="#3b82f6" />
                        </div>
                        <span className="fw-medium" style={{ fontSize: "0.9rem" }}>Email</span>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
      <TestimonialSlider />
      <Footer />
    </>
  );
}
